import { render, staticRenderFns } from "./Deposit.vue?vue&type=template&id=718d515e&"
import script from "./Deposit.vue?vue&type=script&lang=js&"
export * from "./Deposit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports